/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SecurityHelper, SkipLink } from 'sarsaparilla';

import { SiteBanner, AndroidAppBanner } from 'site-kit';

import { AuthModal } from '../auth/AuthModal/AuthModal';
import { ExternalAppBootstrap } from './ExternalAppBootstrap';
import { TopNavAlertBanner } from './TopNavAlertBanner/TopNavAlertBanner';
import { TestEnvironmentBanner } from './TestEnvironmentBanner/TestEnvironmentBanner';
import { ChatSkipLink } from './ChatSkipLink/ChatSkipLink';
import { Navbar } from './Navbar/Navbar';

interface TopNavigationProps {
    isGuestAllowed?: boolean;
}

export function TopNavigationExternal({ isGuestAllowed = true }: TopNavigationProps) {
    const isMobileApp = SecurityHelper.isMobileApp();

    return isMobileApp ? (
        <>
            <ExternalAppBootstrap />
            <SkipLink href="#page-content" position="containerTop" zIndex="high">
                Skip to Main content
            </SkipLink>
        </>
    ) : (
        <>
            <ExternalAppBootstrap />

            <section aria-label="Skip links">
                <SkipLink href="#page-content" position="containerTop" zIndex="high">
                    Skip to Main Content
                </SkipLink>
                <ChatSkipLink />
            </section>

            <AndroidAppBanner />
            <TestEnvironmentBanner />
            <SiteBanner />
            <TopNavAlertBanner />

            <Navbar isGuestAllowed={isGuestAllowed} />

            <AuthModal />
        </>
    );
}
